// External packages
import * as React from 'react';

// Utils
import { twMerge } from 'tailwind-merge';

export type IconNames =
  | 'arrow-up'
  | 'audio'
  | 'box'
  | 'building'
  | 'check'
  | 'chevron-down'
  | 'edit'
  | 'eye'
  | 'eye-slash'
  | 'image'
  | 'loader'
  | 'logout'
  | 'minus'
  | 'plus'
  | 'search'
  | 'ticket'
  | 'trash'
  | 'video'
  | 'x'
  | 'language'
  | 'image'
  | 'map'
  | 'qr'
  | 'bulleted-list'
  | 'numbered-list'
  | 'checks-list'
  | 'bold'
  | 'italic'
  | 'underline'
  | 'strikethrough'
  | 'list'
  | 'list-ordered'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'align-center'
  | 'align-justify'
  | 'align-left'
  | 'align-right'
  | 'blockquote'
  | 'palette'
  | 'link'
  | 'undo'
  | 'redo';

export const Icon: React.FC<
  React.ComponentProps<'svg'> & { name: IconNames }
> = ({ name, className, ...props }) => (
  <svg {...props} className={twMerge('size-4 shrink-0', className)}>
    <use href={`/icons/sprite.svg#${name}`} />
  </svg>
);

export type IconLabeledProps = React.ComponentProps<'div'> & {
  icon: React.ReactNode;
  iconPosition?: 'start' | 'end';
};

export const IconLabeled: React.FC<IconLabeledProps> = ({
  icon,
  iconPosition = 'start',
  className,
  children,
  ...props
}) => (
  <div
    {...props}
    className={twMerge(
      'inline-flex items-center gap-2',
      iconPosition === 'end' && 'flex-row-reverse',
      className
    )}
  >
    {icon}
    {children}
  </div>
);
